/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {activityBulkSearchPageInternal} from '../api'

export const useMutationActivityBulkSearchPageInternal = createReactQueryMutationHook('activityBulkSearchPageInternal', activityBulkSearchPageInternal)
